<template>
  <div class="profile container col-lg-8 col-sm-12 mb-10">
    <Permissioned section="workers.view" vertical>
      <div
        v-for="(section, index) in allSections"
        :oneOfPermissions="getPermissions(section)"
        :key="index"
      >
        <component
          :is="section.component"
          :userData="currentWorker"
          :data-test="section.name"
        />
        <v-divider class="mt-4" />
      </div>
    </Permissioned>
    <BaseFooter>
      <ExpandedButtons>
        <AddToPoolAction :selectedCandidates="selectedCandidates" />
      </ExpandedButtons>
    </BaseFooter>
  </div>
</template>
<script>
import BasicDetails from "@/views/workers/components/WorkerDetails/components/WorkerProfile/components/BasicDetails";
import Experience from "@/views/settings/components/Experience";
import Qualifications from "@/views/settings/components/Qualifications";
import { PERMISSIONS } from "@/constants/workers";
import Permissioned from "@/components/common/Permissioned";
import LanguagesAndSkills from "@/views/settings/components/LanguagesAndSkills";
import Preferences from "@/views/settings/components/Preferences";
import AddToPoolAction from "@/views/workers/components/actions/AddToPoolAction";
import { createNamespacedHelpers } from "vuex";
import { FETCH_TALENT_POOLS } from "@/store/modules/talentPools/actions";
import { TALENT_POOLS_NAMESPACE } from "@/store/modules/talentPools";
import BaseFooter from "@/components/common/BaseFooter";
import { isEmpty } from "lodash";
import ExpandedButtons from "@/components/common/ExpandedButtons";

const { mapActions, mapState } = createNamespacedHelpers(
  TALENT_POOLS_NAMESPACE
);

export default {
  name: "WorkerProfile",
  components: {
    Permissioned,
    BaseFooter,
    AddToPoolAction,
    ExpandedButtons
  },
  data() {
    return {
      allSections: [
        {
          name: "basic-details",
          component: BasicDetails,
          permissions: PERMISSIONS.BASIC_DETAILS
        },
        {
          name: "experience",
          component: Experience,
          permissions: PERMISSIONS.EXPERIENCE
        },
        {
          name: "qualifications",
          component: Qualifications,
          permissions: PERMISSIONS.QUALIFICATIONS
        },
        {
          name: "languages-and-skills",
          component: LanguagesAndSkills,
          permissions: PERMISSIONS.LANGUAGES_AND_SKILLS
        },
        {
          name: "preferences",
          component: Preferences,
          permissions: PERMISSIONS.PREFERENCES
        }
      ]
    };
  },
  created() {
    if (isEmpty(this.talentPools)) {
      this.fetchTalentPools();
    }
  },
  computed: {
    ...mapState({
      talentPools: state => state.talentPools
    }),
    selectedCandidates() {
      return [{ id: this.currentWorker.id }];
    }
  },
  methods: {
    ...mapActions({
      fetchTalentPools: FETCH_TALENT_POOLS
    }),
    getPermissions({ permissions }) {
      if (permissions) {
        return Object.values(permissions);
      }
    }
  },
  props: {
    currentWorker: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="scss"></style>
